var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160528",
    "data-name": "Group 160528",
    transform: "translate(-30 -590)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160425",
    "data-name": "Group 160425",
    transform: "translate(0 314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_147641",
    "data-name": "Rectangle 147641",
    transform: "translate(30 276)",
    fill: "rgba(255,255,255,0.09)",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_503",
    "data-name": "Line 503",
    y2: 22,
    transform: "translate(41.5 276.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_504",
    "data-name": "Line 504",
    x2: 11,
    transform: "translate(41.5 286.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu3);
export default __webpack_public_path__ + "static/media/menu3.477b67bc18cd5673debb7d7e645fad3a.svg";
export { ForwardRef as ReactComponent };